import { HYPER_MONITORING_BANK_SCHEMA_FIELDS } from 'constants/hyper-monitoring.constants';
import type {
	HyperMonitoringBankSchemaField,
	HyperMonitoringOperationRecord,
} from 'types/hyper-monitoring.types';

const hasBankSchemaValue = (value: unknown) => value !== null && value !== undefined && value !== '';

const toBoUserDisplayName = (boUser: any) => {
	if (!boUser) {
		return null;
	}
	const displayName = `${boUser.firstName || ''} ${boUser.lastName || ''}`.trim();
	return displayName || null;
};

const buildBankSchemaFields = (beneficiary: any): HyperMonitoringBankSchemaField[] =>
	HYPER_MONITORING_BANK_SCHEMA_FIELDS.flatMap(({ beneficiaryKey, labelKey }) => {
		const value = beneficiary[beneficiaryKey];
		if (!hasBankSchemaValue(value)) {
			return [];
		}
		return [{ key: beneficiaryKey, labelKey, value }];
	});

/** Maps GET /beneficiary/:id + list triage row into the manual-documentation modal shape. */
export const mapHyperMonitoringManualDocumentationDetails = (
	row: HyperMonitoringOperationRecord,
	beneficiary: any
) => ({
	operationId: row.operationId,
	companyHebrewName: row.companyHebrewName,
	hyperAccountNumber: row.hyperAccountNumber,
	beneficiaryName: beneficiary.companyName ?? beneficiary.nickname ?? row.beneficiaryName,
	hyperFailureReceivedAt: row.hyperFailureReceivedAt,
	status: row.status,
	entityId: row.entityId,
	companyId: row.companyId,
	lastUpdatedAt: beneficiary.updatedAt ?? null,
	openBeneficiaryId: String(beneficiary.id),
	beneficiaryNickname: beneficiary.nickname ?? null,
	beneficiaryStatus: beneficiary.status ?? null,
	identityNumber: beneficiary.identificationNumber ?? null,
	beneficiaryCountry: beneficiary.country?.name ?? null,
	bankAccountCountry: beneficiary.bankAccountCountry?.name ?? null,
	city: beneficiary.city ?? null,
	street: beneficiary.address ?? null,
	currency: beneficiary.currency?.code ?? null,
	bankSchemaFields: buildBankSchemaFields(beneficiary),
	accountHolder: beneficiary.bankAccountHolderName ?? null,
	wcCaseId: beneficiary.wcUuid ?? null,
	rejectionReason: beneficiary.boNotes ?? null,
	sourceBoUser: toBoUserDisplayName(beneficiary.boApprovedByUser),
});
